import { CombinedActionTypes } from '../../actionsFactory';

export interface State {
  loading: boolean;
  error?: any;
  data: string[];
  meta?: {
    page: number;
    totalHits: number;
    pageSize: number;
  };
}

export const initState: State = {
  loading: false,
  error: null,
  data: [],
};

const appendOrReplace = (
  currentContacts: string[],
  newContacts: { id: string }[],
): string[] => [
  ...currentContacts,
  ...newContacts
    .filter((contact) => !currentContacts.includes(contact.id))
    .map(({ id }) => id),
];

const prependOrReplace = (
  currentContacts: string[],
  newContacts: { id: string }[],
): string[] => [
  ...newContacts.map(({ id }) => id),
  ...currentContacts.filter(
    (id) => !newContacts.some(({ id: newContactId }) => newContactId === id),
  ),
];

export default (state: State, action: CombinedActionTypes): State => {
  switch (action.type) {
    case 'CONTACTS:FETCHING':
      return {
        ...state,
        loading: true,
        error: null,
        meta: {
          ...state.meta,
          page: action.payload.page,
        },
      };
    case 'CONTACTS:FETCHING_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case 'CONTACTS:FETCHING_SUCCESS':
      return {
        ...state,
        loading: false,
        error: null,
        data:
          parseInt(action.payload.result.meta.page, 10) === 1
            ? prependOrReplace(state.data, action.payload.result.data)
            : appendOrReplace(state.data, action.payload.result.data),
        meta: {
          ...action.payload.result.meta,
          page: parseInt(action.payload.result.meta.page, 10),
          pageSize: parseInt(action.payload.result.meta.pageSize, 10),
          totalHits: parseInt(action.payload.result.meta.totalHits, 10),
        },
      };
    default:
      return state;
  }
};
